{
  "blocks": [
    {
      "id": "proc-transabdominal-ultrasound",
      "kind": "procedure",
      "tags": ["testing", "her", "clinic-visit"],
      "title": "Transabdominal ultrasound",
      "subtitle": "External ultrasound to visualize pelvic organs through the abdomen",
      "body": {
        "procedureName": "Transabdominal ultrasound",
        "category": "diagnostic",
        "description": "A non-invasive imaging exam where an ultrasound probe is moved across your lower abdomen to visualize the uterus, ovaries, and surrounding structures.",
        "howItWorks": "You lie on an exam table and a warm gel is applied to your lower abdomen. The sonographer moves a smooth transducer across your skin, which sends sound waves that bounce off internal structures to create real-time images on a screen. The images show the size and shape of the uterus, ovaries, and any visible abnormalities such as fibroids or large cysts. A full bladder is usually required because it creates an acoustic window that improves image clarity.",
        "duration": "15–30 minutes",
        "anesthesia": "none",
        "painAndComfort": [
          "The exam is usually painless; a full bladder or firm probe pressure can feel uncomfortable briefly."
        ],
        "whatToExpect": [
          "You'll need a full bladder, so drink water as instructed before the exam",
          "The gel feels warm and the probe pressure is gentle",
          "The sonographer may press firmly at times to get clearer images",
          "Images are reviewed by your doctor, usually the same day or within 24 hours",
          "No downtime: you can resume normal activities immediately"
        ],
        "prepInstructions": [
          "Drink 2–3 glasses of water about an hour before your appointment and avoid urinating",
          "Wear comfortable clothing that allows easy access to your lower abdomen",
          "No fasting is required"
        ],
        "risks": [
          "No known risks: ultrasound uses sound waves, not radiation",
          "Mild discomfort from the full bladder or probe pressure"
        ],
        "forWhom": "her",
        "frBody": {
          "procedureName": "Échographie sus-pubienne",
          "description": "Examen d'imagerie non invasif au cours duquel une sonde d'échographie est déplacée sur le bas de l'abdomen pour visualiser l'utérus, les ovaires et les structures environnantes.",
          "howItWorks": "Vous êtes allongée sur une table d'examen et un gel tiède est appliqué sur le bas de l'abdomen. L'échographiste déplace une sonde lisse sur la peau ; elle émet des ondes sonores qui se réfléchissent sur les structures internes pour produire des images en temps réel à l'écran. Les images montrent la taille et la forme de l'utérus, des ovaires et toute anomalie visible (fibromes, gros kystes). Une vessie pleine est généralement nécessaire car elle constitue une fenêtre acoustique qui améliore la qualité des images.",
          "duration": "15 à 30 minutes",
          "whatToExpect": [
            "Vous aurez besoin d'avoir la vessie pleine ; buvez de l'eau selon les indications avant l'examen",
            "Le gel est tiède et la pression de la sonde est douce",
            "L'échographiste peut appuyer fermement par moments pour obtenir des images plus nettes",
            "Les images sont examinées par votre médecin, généralement le jour même ou sous 24 heures",
            "Pas de récupération nécessaire : vous pouvez reprendre vos activités immédiatement"
          ],
          "prepInstructions": [
            "Buvez 2 à 3 verres d'eau environ une heure avant le rendez-vous et n'urinez pas",
            "Portez des vêtements confortables permettant d'accéder facilement au bas de l'abdomen",
            "Aucun jeûne nécessaire"
          ],
          "risks": [
            "Aucun risque connu : l'échographie utilise des ondes sonores, pas de rayonnements",
            "Léger inconfort lié à la vessie pleine ou à la pression de la sonde"
          ]
        }
      },
      "sources": [
        {
          "title": "AIUM Practice Parameter for the Performance of an Ultrasound Examination of the Female Pelvis",
          "authors": "AIUM/ACR/ACOG/SRU",
          "journal": "Journal of Ultrasound in Medicine",
          "year": 2020,
          "url": "https://onlinelibrary.wiley.com/doi/10.1002/jum.15205",
          "evidenceLevel": "guideline"
        }
      ]
    }
  ],
  "relationships": [],
  "localeVariants": []
}
